export default {
  setProductDetails ({ commit }, payload) {
    commit('setProductDetails', payload)
  }
}
